// Camada legada. Nova estrutura em:
//   - src/types            (tipagens)
//   - src/lib/api/client   (cliente HTTP com VITE_API_URL)
//   - src/services/*       (serviços por domínio)
//   - src/hooks/queries    (hooks React Query)
// Mantido para retro-compatibilidade de imports antigos.

export type {
  Vehicle,
  VehicleStatus,
  Alert,
} from "@/types";

export { API_URL as API_BASE_URL } from "@/lib/api/client";
import { vehiclesService } from "@/services/vehicles.service";
import { alertsService } from "@/services/alerts.service";

export const fetchVehicles = () => vehiclesService.list();
export const fetchAlerts = () => alertsService.list();
